import ContractsTaxiForwardingContractRequest from "../../../../api/raily/contracts/taxi-forwarding/contract/contracts-taxi-forwarding-contract.request";
import ContractsTaxiForwardingContractParams from "./contracts-taxi-forwarding-contract-params";

const create = (
  params: ContractsTaxiForwardingContractParams,
): ContractsTaxiForwardingContractRequest => {
  return {
    producerId: params.producerId,
    selectedTaxiCorporationId: params.selectedTaxiCorporationId,
  };
};

const contractsTaxiForwardingContractParamsFactory = {
  create,
};

export default contractsTaxiForwardingContractParamsFactory;
